import type { RouterOutputs } from "@repo/api";
import type { ReactNode } from "react";
import { useEffect } from "react";
import { useShallow } from "zustand/react/shallow";

import EmployeeDialog from "~/components/employee/employee-dialog";
import EmployeeProfile from "~/components/employee/employee-profile";
import { EmployeeContext } from "~/hooks/use-employee";
import { api } from "~/lib/api";
import { useLoadingStore } from "~/stores/use-loading-store";
import { UnsavedChangesProvider } from "./unsaved-changes-provider";

export type Employee = RouterOutputs["employee"]["getAll"][number];

interface EmployeeProviderProps {
  children: ReactNode;
}

export function EmployeeProvider({ children }: EmployeeProviderProps) {
  const { data: employees, isFetching: isEmployeesLoading } =
    api.employee.getAll.useQuery(undefined, {
      initialData: [],
    });

  const { setLoadingStage } = useLoadingStore(
    useShallow((state) => ({
      setLoadingStage: state.setCurrentLoadingStage,
    })),
  );

  useEffect(() => {
    if (isEmployeesLoading) {
      setLoadingStage("employees");
    } else {
      setLoadingStage(undefined);
    }
  }, [isEmployeesLoading, setLoadingStage]);

  const context = {
    employees,
  };

  return (
    <EmployeeContext.Provider value={context}>
      {children}
      <UnsavedChangesProvider>
        <EmployeeDialog />
      </UnsavedChangesProvider>
    </EmployeeContext.Provider>
  );
}
